<template>
  <div class="banner">
    <img src="../assets/images/banner.png" alt="">
  </div>
</template>
<script>
  export default {
    data() {
      return {


      };
    },
  };
</script>

<style lang="less" scoped>
  .banner{
    font-size: 0px;
    img{width: 100%;}
  }

</style>



// WEBPACK FOOTER //
// src/components/banner.vue